class StickyProduct extends HTMLElement {
  constructor() {
    super();

    this.isStickyVisible = false;
  }

  connectedCallback() {
    this.boundUpdate = this.update.bind(this);
    document.addEventListener('scroll', this.boundUpdate);
    window.addEventListener('resize', this.boundUpdate);

    this.boundScrollToOptions = this.onChooseOptionsClick.bind(this);
    this.addEventListener('click', this.boundScrollToOptions);

    this.update();
  }

  disconnectedCallback() {
    document.removeEventListener('scroll', this.boundUpdate);
    window.removeEventListener('resize', this.boundUpdate);
    this.removeEventListener('click', this.boundScrollToOptions);
  }

  onChooseOptionsClick(event) {
    const trigger = event.target.closest('[data-scroll-to-options]');
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();

    const optionsEl = document.querySelector('variant-selects');
    if (!optionsEl) return;

    const headerOffset = 80;
    const top =
      optionsEl.getBoundingClientRect().top + window.scrollY - headerOffset;

    window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
  }

  update() {
    const productInfo = document.querySelector('.product-form__buttons');
    const rect = productInfo.getBoundingClientRect();
    const belowFold = rect.bottom < 0;

    if (belowFold && !this.isStickyVisible) {
      this.style.display = 'block';
      this.isStickyVisible = true;
    } else if (!belowFold && this.isStickyVisible) {
      this.style.display = 'none';
      this.isStickyVisible = false;
    }
  }
}

customElements.define('sticky-product', StickyProduct);
